// extracted by mini-css-extract-plugin
export default {"banner":"header-tag_banner__jAMsY","left":"header-tag_left__Hz0FC","middle":"header-tag_middle__Wim5g","right":"header-tag_right__zSbqC"};